<template>
     <IndexBase @auth="onAuth($event)" action="Index" controller="QcFinal"></IndexBase>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{ mode }}] QC Final
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Created_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Edited_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Deleted_Date">
                                    <div class="row">
                                        <i class="pi pi-trash" /> {{ this.$formatDateTime(header.Deleted_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Deleted_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Draft" class="p-button-secondary mr-2" @click="confirmDraft($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && (header && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && header.Status != this.$APPROVAL_STATUS.APPROVED && header.Status != this.$APPROVAL_STATUS.REVISED && header.Status != this.$APPROVAL_STATUS.DONE)"/>
                        <Button icon="pi pi-upload" label="Save" class="p-button-success" @click="confirm($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && !onlyDraft" />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">

                            <FormField :labelName="$t('doc_date')" fieldName="Date_Time" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <DatePicker name="Date_Time" v-model="header.Date_Time" type="text"
                                :placeholder="$t('doc_date')" v-if="header" dateFormat="dd/mm/yyyy"
                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                <small
                                    v-if="header && !header.Date_Time && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('doc_date')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('company_contractor')" fieldName="Contractor_Code" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect name="Contractor_Code" :filter="true"  v-if="header"
                                    v-model="header.Contractor_Code" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/contractor_code'"
                                    :minLength="0"
                                    :params="{ docDate: (this.header.Date_Time != null ? this.header.Date_Time  : null)}"  
                                    :disabled="true"
                                    />
                                    <small v-if="header && !header.Contractor_Code && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('company_contractor')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('area_plant')" fieldName="Area_Plant" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Area_Plant" v-model="header.Area_Plant" required="true" type="text"
                                    :placeholder="$t('area_plant')" v-if="header"
                                    :disabled="true" />
                                    <small v-if="header && !header.Area_Plant && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('area_plant')) }}
                                     </small>
                            </FormField>

                            <FormField :labelName="$t('scope')" fieldName="Scope" v-model="header" labelClass="col-4" fieldClass="col-6">

                                    <CustomMultiSelect  v-if="header" name="Scope" 
                                            v-model="header.Scope"  
                                            :url="$API_URL + 'list/lookup'"
                                            :params="{ group: $LOOKUP_GROUP.SCOPE_QC_FINAL }" 
                                            :minLength="0" 
                                            :filter="true"
                                            :placeholder="$t('scope')"
                                            @change="onChangeScope($event)"
                                            @remove="onChangeScope($event)"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                   <small v-if="header && !header.Scope && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('scope')) }}
                                     </small>
                            </FormField>

                            <FormField :labelName="$t('no_spk')" fieldName="No_SPK" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="No_SPK" v-model="header.No_SPK" required="true" type="text"
                                    :placeholder="$t('no_spk')" v-if="header"
                                    :disabled="true" />
                            </FormField>

                            <FormField :labelName="$t('no_spo')" fieldName="Area_Plant" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && header.No_SPO != null">
                                <InputText name="Area_Plant" v-model="header.No_SPO" required="true" type="text"
                                    :placeholder="$t('no_spo')" v-if="header"
                                    :disabled="true" />
                                    <small v-if="header && !header.No_SPO && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('no_spo')) }}
                                     </small>
                            </FormField>

                            <FormField :labelName="$t('report_number')" fieldName="Report_Number" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Report_Number" v-model="header.Report_Number" required="true" type="text"
                                    :placeholder="$t('report_number')" v-if="header"
                                    :disabled="true" />
                            </FormField>

                            <FormField :labelName="$t('inspector')" fieldName="Username_Inspector" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Username_Inspector" v-model="header.Username_Inspector" required="true" type="text"
                                    :placeholder="$t('inspector')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                <small v-if="header && !header.Username_Inspector && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('inspector')) }}
                                 </small>
                            </FormField>

                            <FormField :labelName="$t('contractor_title')" fieldName="Contractor_Title" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <Textarea name="Contractor_Title" v-model="header.Contractor_Title" required="true" type="text"
                                    :placeholder="$t('contractor_title')" v-if="header"
                                    :disabled="true" autoResize />
                                    <small v-if="header && !header.Contractor_Title && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('contractor_title')) }}
                                     </small>
                            </FormField>
                        </div>  
                        <div class="col-6">
                            
                            <FormField :labelName="$t('status')" fieldName="Status" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Status" v-model="header.Status" required="true" type="text"
                                    :placeholder="$t('status')" v-if="header"
                                    :disabled="true" />
                            </FormField>


                            <FormField :labelName="$t('comments')" fieldName="Comments" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <Textarea name="Comments" v-model="header.Comments" required="true" type="text"
                                    :placeholder="$t('comments')" v-if="header" 
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" autoResize />
                                    <small v-if="header && !header.Comments && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('comments')) }}
                                     </small>
                            </FormField>
                                  
                            <FormField :labelName="$t(labelAppr1)" fieldName="Username_QC_Head" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr1">
                                <CustomSelect name="Username_QC_Head" :filter="true"  v-if="header"
                                    v-model="header.Username_QC_Head" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As1, user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.FINAL_QC, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_QC_Head && submitted2 && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr1)) }}
                                </small>
                            </FormField>
                            <FormField :labelName="$t('project_qc_sipil')" fieldName="Username_QC_Sipil" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect name="Username_QC_Sipil" :filter="true"  v-if="header"
                                    v-model="header.Username_QC_Sipil" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/username_qc'"
                                    :minLength="0"
                                    :params="{job_postion : this.$UserLevel.QC_SIPIL, user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.FINAL_QC, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                    <small v-if="header && !header.Username_QC_Sipil && is_sipil && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('project_qc_sipil')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('project_qc_mekanikal')" fieldName="Username_QC_Mekanikal" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect name="Username_QC_Mekanikal" :filter="true"  v-if="header"
                                    v-model="header.Username_QC_Mekanikal" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/username_qc'"
                                    :minLength="0"
                                    :params="{job_postion : this.$UserLevel.QC_MEKANKAL, user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.FINAL_QC, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                    <small v-if="header && !header.Username_QC_Mekanikal && is_mekanikal && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('project_qc_mekanikal')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('project_qc_electrical')" fieldName="Username_QC_Electrical" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect name="Username_QC_Electrical" :filter="true"  v-if="header"
                                    v-model="header.Username_QC_Electrical" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/username_qc'"
                                    :minLength="0"
                                    :params="{job_postion : this.$UserLevel.QC_ELECTRICAL, user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.FINAL_QC, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                    <small v-if="header && !header.Username_QC_Electrical && is_electrical && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('project_qc_electrical')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('reason')" fieldName="Reason" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && (header.Status == this.$APPROVAL_STATUS.DONE || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL)">
                                <InputText name="Reason" v-model="header.Reason" required="true" type="text"
                                    :placeholder="$t('reason')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT|| header.Status != this.$APPROVAL_STATUS.DONE"/>
                                    <small v-if="header &&((!header.Reason && header.Status == this.$APPROVAL_STATUS.DONE)) && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                    </small>
                            </FormField>

                        </div>

                        <div class="col-12">
                            <DataTable v-if="header" :loading="!header" :value="header.Participants ? header.Participants : null"
                                responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                <template #header>
                                    <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                                        <span class="text-900 font-bold">Participants</span>
                                    </div>
                                </template>
                                <Column :exportable="false" style="width:30px">
                                    <template #header>
                                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                            @click="addDetailParticipant()"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    </template>
                                    <template #body="slotProps">
                                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                            @click="deleteDetailParticipant(slotProps);onScopeDetail()"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                            v-show="slotProps.data.mode != 'Delete'" />
                                    </template>
                                </Column>
                                <Column field="Name" :header="$t('name')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('name')" @change="onCellEditCompleteParticipant(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                        </div>
                                    </template>
                                </Column>

                                <Column field="Position" :header="$t('position')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('position')" @change="onCellEditCompleteParticipant(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                        </div>
                                    </template>
                                </Column>

                                <Column field="Company" :header="$t('company')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('company')" @change="onCellEditCompleteParticipant(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>

                        <div class="col-12">
                            <DataTable v-if="header" :loading="!header" :value="header.Details ? header.Details.filter(a=> a.mode != this.$FORM_MODE_DELETE) : null"
                                responsiveLayout="scroll" class="p-datatable-sm editable-cells-table" v-model:expandedRows="header.Details">
                                <template #header>
                                    <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                                        <span class="text-900 font-bold">Inspections</span>
                                    </div>
                                </template>
                                <Column :exportable="false" style="width:30px">
                                    <template #header>
                                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                            @click="addDetail()"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    </template>
                                    <template #body="slotProps">
                                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                            @click="deleteDetail(slotProps);onScopeDetail()"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                            v-show="slotProps.data.mode != 'Delete'" />
                                    </template>
                                </Column>

                                <Column field="Description" :header="$t('inspection')" Key="Id" style="width:10px;">
                                    <template #body="slotProps">
                                        {{ slotProps.data.mode != 'Delete' ? slotProps.data[slotProps.column.props.field] : ""}}
                                    </template>
                                </Column>

                                <Column>
                                    <template #body="slotProps">
                                        {{ slotProps.data.mode != 'Delete' ? "#" + (slotProps.index + 1)  : ""}}
                                    </template>
                                </Column>

                                <template #expansion="slotPropsHeader">
                                    <div class="p-fluid orders-subtable margin" v-show="slotPropsHeader.data.mode != 'Delete'" :style="{padding:slotPropsHeader.data.mode != 'Delete' ? '10px' : ''}">
                                        <DataTable v-if="header.Details" :loading="!header.Details" :value="slotPropsHeader.data.Inspections ? slotPropsHeader.data.Inspections : null"
                                            responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                                <template #header>
                                                    <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                                                        <span class="text-900 font-bold">Inspections Photos</span>
                                                    </div>
                                                </template>
                                                <Column :exportable="false" style="width:30px">
                                                    <template #header>
                                                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                                            @click="addDetailInspection(slotPropsHeader)"
                                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                                    </template>
                                                    <template #body="slotProps">
                                                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                                            @click="deleteDetailInspection(slotPropsHeader, slotProps);onScopeDetail()"
                                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || slotProps.data.Is_Disable"
                                                            v-show="slotProps.data.mode != 'Delete'" />
                                                    </template>
                                                </Column>

                                                <Column field="Scope" :header="$t('scope')" Key="Id">
                                                    <template #body="slotProps">
                                                        <div class="p-fluid">
                                                            <CustomSelect
                                                            v-model="slotProps.data[slotProps.column.props.field]" 
                                                            :url="$API_URL + 'list/lookup'"
                                                            :params="{ group: $LOOKUP_GROUP.SCOPE_QC_FINAL }" 
                                                            :minLength="0" 
                                                            :filter="true"
                                                            @change="onCellEditCompleteInspection(slotProps,slotPropsHeader);onScopeDetail()"
                                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || slotProps.data.Is_Disable"
                                                            v-show="slotProps.data.mode != 'Delete'"
                                                            />
                                                        </div>
                                                    </template>
                                                </Column>

                                                <Column field="Identitas" :header="$t('id')" Key="Id">
                                                    <template #body="slotProps">
                                                        <div class="p-fluid">
                                                            <InputText 
                                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                                :placeholder="$t('id')" @change="onCellEditCompleteInspection(slotProps,slotPropsHeader)"
                                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || slotProps.data.Is_Disable"
                                                                v-show="slotProps.data.mode != 'Delete'" style="width:150px;" maxlength="50"/>
                                                                <br/>
                                                                <small v-if="header && !slotProps.data[slotProps.column.props.field] && submitted && mode != this.$FORM_MODE_DELETE"
                                                                    class="p-error">{{ $t('is_required').replace('Value', $t('id')) }}
                                                                </small>
                                                        </div>
                                                    </template>
                                                </Column>

                                                <Column field="Date" :header="$t('date')" Key="Id">
                                                    <template #body="slotProps">
                                                        <div class="p-fluid">
                                                            <DatePicker name="Act_Date" v-model="slotProps.data[slotProps.column.props.field]"
                                                            :placeholder="$t('date')" @input="onCellEditCompleteInspection(slotProps,slotPropsHeader)" @date-select="onCellEditCompleteInspection(slotProps,slotPropsHeader)"
                                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || slotProps.data.Is_Disable"
                                                            v-show="slotProps.data.mode != 'Delete'" style="width:150px;"/>

                                                        </div>
                                                    </template>
                                                </Column>

                                                <Column field="Currently" :header="$t('currently')" Key="Id">
                                                    <template #body="slotProps">
                                                        <div class="p-fluid">
                                                                <CustomFileUpload 
                                                                :fileModels="slotProps.data.files_data1"
                                                                :multiple="false"
                                                                :maxFileSize="5242880" 
                                                                :showUploadButton="false"
                                                                :showCancelButton="false" 
                                                                :customUpload="false" 
                                                                accept="image/*"
                                                                @select="onFileSelect1($event, slotProps.data)"
                                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || slotProps.data.Is_Disable"
                                                                @remove="onFileRemove1($event, slotProps.data)"
                                                                @change="onCellEditCompleteInspection(slotProps,slotPropsHeader)"
                                                                @input="onCellEditCompleteInspection(slotProps,slotPropsHeader)"
                                                                v-show="slotProps.data.mode != 'Delete'" />
                                                        </div>
                                                    </template>
                                                </Column>

                                                <Column field="viewFiles1" :header="$t('download_currently')" Key="Id" style="width:20px;">
                                                    <template #body="slotProps">
                                                        <div class="p-fluid">
                                                            <CustomFileUpload
                                                            :fileModels="slotProps.data.viewFiles1"
                                                            :multiple="false" 
                                                            :showUploadButton="false" 
                                                            :showCancelButton="false" 
                                                            :customUpload="false" 
                                                            @select="onFileSelect" 
                                                            @remove="onFileRemove" 
                                                            :viewOnly="true" 
                                                            :showHeader="false"
                                                            @download="onDownloadFile1"
                                                            v-show="slotProps.data.mode != 'Delete'"
                                                            />                        
                                                        </div>
                                                    </template>
                                                </Column>
                                                
                                                <Column field="Previously" :header="$t('previously')" Key="Id">
                                                    <template #body="slotProps">
                                                        <div class="p-fluid">
                                                                <CustomFileUpload 
                                                                :fileModels="slotProps.data.files_data"
                                                                :multiple="false" 
                                                                :maxFileSize="5242880" 
                                                                :showUploadButton="false"
                                                                :showCancelButton="false" 
                                                                :customUpload="false" 
                                                                accept="image/*"
                                                                @select="onFileSelect($event, slotProps.data)"
                                                                :disabled="true"
                                                                @remove="onFileRemove($event, slotProps.data)"
                                                                @change="onCellEditCompleteInspection(slotProps,slotPropsHeader)"
                                                                @input="onCellEditCompleteInspection(slotProps,slotPropsHeader)"
                                                                v-show="slotProps.data.mode != 'Delete'" />
                                                        </div>
                                                    </template>
                                                </Column>
                                            
                                                <Column field="viewFiles2" class="" :header="$t('download_inspection')" Key="Id" style="width:20px;">
                                                    <template #body="slotProps">
                                                        <div class="p-fluid">
                                                            <CustomFileUpload
                                                            :fileModels="slotProps.data.viewFiles2"
                                                            :multiple="false" 
                                                            :showUploadButton="false" 
                                                            :showCancelButton="false" 
                                                            :customUpload="false" 
                                                            @select="onFileSelect" 
                                                            @remove="onFileRemove" 
                                                            :viewOnly="true" 
                                                            :showHeader="false"
                                                            @download="onDownloadFile2"
                                                            v-show="slotProps.data.mode != 'Delete'"/>                        
                                                        </div>
                                                    </template>
                                                </Column>

                                              
                                                <Column field="Inspection_Currently" :header="$t('inspection_currently')" Key="Id" style="width:5px;">
                                                    <template #body="slotProps">
                                                        <div class="p-fluid">
                                                            <InputNumber inputId="minmax"
                                                                v-model="slotProps.data[slotProps.column.props.field]"
                                                                :placeholder="$t('inspection') + ' #1 / 2 / 3 / 4 / 5 *'" 
                                                                @change="onCellEditCompleteInspection(slotProps,slotPropsHeader)" 
                                                                @input="onCellEditCompleteInspection(slotProps,slotPropsHeader)"
                                                                :disabled="true"
                                                                v-show="slotProps.data.mode != 'Delete'" :min="0" :max="5"/>
                                                        </div>
                                                    </template>
                                                </Column>

                                                <Column field="Inspection_Previosly" :header="$t('inspection_previosly')" Key="Id" style="width:5px;">
                                                    <template #body="slotProps">
                                                        <div class="p-fluid">
                                                            <InputNumber 
                                                                v-model="slotProps.data[slotProps.column.props.field]"
                                                                :placeholder="$t('inspection') + ' #1 / 2 / 3 / 4 / 5 *'" 
                                                                @change="onCellEditCompleteInspection(slotProps,slotPropsHeader)" 
                                                                @input="onCellEditCompleteInspection(slotProps,slotPropsHeader)"
                                                                :disabled="true"
                                                                v-show="slotProps.data.mode != 'Delete'" :min="0" :max="5"/>
                                                        </div>
                                                    </template>
                                                </Column>
                                                
                                                <Column field="Result" :header="$t('result')" Key="Id">
                                                    <template #body="slotProps">
                                                        <div class="p-fluid">
                                                            <CustomSelect
                                                                v-model="slotProps.data[slotProps.column.props.field]" 
                                                                :url="$API_URL + 'list/lookup'"
                                                                :params="{ group: $LOOKUP_GROUP.INSPECTION_RESULT_QC }" 
                                                                :minLength="0" 
                                                                :filter="true"
                                                                @change="onCellEditCompleteInspection(slotProps,slotPropsHeader)"
                                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || slotProps.data.Is_Disable"
                                                                v-show="slotProps.data.mode != 'Delete'"
                                                            />
                                                        </div>
                                                    </template>
                                                </Column>

                                                <Column field="Issue" :header="$t('issue')" Key="Id">
                                                    <template #body="slotProps">
                                                        <div class="p-fluid">
                                                            <InputText 
                                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                                :placeholder="$t('issue')" @change="onCellEditCompleteInspection(slotProps,slotPropsHeader)"
                                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || slotProps.data.Is_Disable"
                                                                v-show="slotProps.data.mode != 'Delete'" style="width:150px;"/>
                                                        </div>
                                                    </template>
                                                </Column>

                                                <Column field="Rectification" :header="$t('rectification')" Key="Id">
                                                    <template #body="slotProps">
                                                        <div class="p-fluid">
                                                            <InputText 
                                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                                :placeholder="$t('rectification')" @change="onCellEditCompleteInspection(slotProps,slotPropsHeader)"
                                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || slotProps.data.Is_Disable"
                                                                v-show="slotProps.data.mode != 'Delete'" style="width:150px;"/>
                                                        </div>
                                                    </template>
                                                </Column>

                                                <Column :header="$t('action')" Key="Id" v-if="this.$store.getters.getJobPosition.includes(this.$UserLevel.ADMIN_QC)">
                                                    <template #body="slotProps">
                                                        <Button icon="pi pi-check" class="p-button-rounded p-button-info mr-2 p-button-sm"
                                                            @click="checkDetailInspection(slotProps.data);onCellEditCompleteInspection(slotProps,slotPropsHeader)"
                                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                            v-show="slotProps.data.mode != 'Delete'"/>

                                                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-info mr-2 p-button-sm"
                                                            @click="isDisabledDetailInspection(slotProps.data);onCellEditCompleteInspection(slotProps,slotPropsHeader)"
                                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                            v-show="slotProps.data.mode != 'Delete'"/>
                                                    </template>
                                                </Column>

                                                <Column field="Log_Date" :header="$t('log_date')" Key="Id" v-if="this.$store.getters.getJobPosition.includes(this.$UserLevel.ADMIN_QC)">
                                                    <template #body="slotProps">
                                                        <div class="p-fluid">
                                                            <DatePicker name="Log_Date" v-model="slotProps.data[slotProps.column.props.field]"
                                                            :placeholder="$t('log_date')" @input="onCellEditCompleteInspection(slotProps,slotPropsHeader)" @date-select="onCellEditCompleteInspection(slotProps,slotPropsHeader);checkDetailInspection(slotProps.data)"
                                                            :disabled="true"
                                                            v-show="slotProps.data.mode != 'Delete'" style="width:150px;"/>

                                                        </div>
                                                    </template>
                                                </Column>
                                        </DataTable>
                                    </div>  
                                </template>
                            
                            </DataTable>
                        </div>
                        <div class="col-12 mt-4" v-if="this.mode != this.$FORM_MODE_CREATE">
                            <TabView>
                                <TabPanel :header="$t('log_history')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.dataModelReqLogs"
                                        :dataRequestLog="this.dataRequestLogs" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('release_approval')">
                                    <ChangeHistory angeHistory v-if="this.header" :modelValue="this.dataModelRelease"
                                        :dataRequestLog="this.dataRelease" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('Change_History')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.detailLog" :dataRequestLog="this.dataChangesLog" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                            </TabView>
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </form>
</template>


<script>
import moment from 'moment';
import IndexBase from '../Helper/IndexBase.vue';
export default {
    name: "Editor",
    components: {
        IndexBase
    },  
    data() {
        return {
            indexName: "QcFinalIndex",
            url: this.$API_URL + "qcfinal/",
            header: null,
            detail: null,
            mode: "",
            submitted: false,
            id: 0,
            mainid : 0,
            formEditable: true,
            dataModelReqLogs: [],
            dataRequestLogs: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Action By" },
                { field: "Action", header: "Action" },
                { field: "Action_Date", header: "Action Date" },
                { field: "Notes", header: "Notes" },
            ],
            dataModelRelease: [],
            dataRelease: this.$dataRelease,
            viewFiles : null,
            participant : null,
            inspection : null,
            dataModelChild : [],
            dataChild: [
                { field: "report_no", header: "Report No" },
                { field: "no", header: "Inspection" },
                { field: "status", header: "Status" },
            ],
            is_mekanikal : false,
            is_electrical : false,
            is_sipil : false,
            detailLog : null,
            dataChangesLog:this.$dataChangesLog,
            labelAppr1 : "",
            submitted2 : false,
            onlyDraft: false,
        }
    },
    methods: {
        onAuth(event) {
            this.onlyDraft = event.onlyDraft;
        },  
        onScopeDetail(){
            let self = this;
            var arrInsepction = [];
            var details = self.header.Details.filter(a=> a.mode != this.$FORM_MODE_DELETE)
            details.forEach(a => {
                    var inspection = a.Inspections.filter(a=> a.mode != this.$FORM_MODE_DELETE).map(x=> x.Scope);
                    arrInsepction.push(inspection);
            });
          
            this.is_mekanikal =  arrInsepction.filter(a=> a.includes("MEKANIKAL")).length > 0;
            this.is_electrical = arrInsepction.filter(a=> a.includes("ELECTRICAL")).length > 0;
            this.is_sipil =  arrInsepction.filter(a=> a.includes("SIPIL")).length > 0;

        },
        checkIfArrayIsUnique(myArray) {
            return myArray.length !== new Set(myArray).size;
        },
        checkDetailInspection(data){
            if(!data.Is_Disable){
                data.Is_Disable = true;
                data.Log_Date = new Date();
            }
        },
        isDisabledDetailInspection(data){
            if(data.Is_Disable){
                data.Is_Disable = false;
            }
        },
        onChangeScope(e){
            if(e.length > 0){
                this.is_mekanikal = e.includes('MEKANIKAL');
                this.is_electrical = e.includes('ELECTRICAL');
                this.is_sipil = e.includes('SIPIL'); 
            }else{
                this.is_mekanikal = false;
                this.is_electrical = false;
                this.is_sipil = false;
            }
        },
        onClickAcceptRepair(){
            if(this.header && this.header.Accept_Repair == this.$Accept_Repair.ACCEPTED)
                this.header.Days = 0;    
        },
        getData() {
            var self = this;
        
            this.$axios.get(this.url + this.mainid + "/" +this.id + "/" + this.mode)
                .then((response) => {

                    if(!response.data.success){
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });   
                        return;
                    }

                    self.header = response.data.data.header;
                    self.header.mode = self.mode;
                    self.dataModelReqLogs = response.data.data.header.request_log;
                    self.dataModelRelease = response.data.data.header.approval_log;
                    self.participant = response.data.data.participant;
                    self.inspection = response.data.data.inspection;
                    self.dataModelChild = response.data.data.header.listChild;
                    self.detail = response.data.data.detail;
                    self.detailLog = self.header.DetailLog;
                    
                    var arrInsepction = [];
                    if(self.mode != this.$FORM_MODE_CREATE &&  self.header.Scope != null)
                        self.header.Scope = self.header.Scope.split(',');

                    self.header.Details.forEach(a => {
                        arrInsepction.push(a.Inspections.map(x=> x.Scope));
                    });

                    var listAppr = response.data.data.listPicAppr;
                    if(listAppr.length > 0)
                    {
                        listAppr.forEach(a=>{
                            if(a.Sign_Position == 1){
                                self.labelAppr1 = a.Approval_As;
                                self.header.Appr_As1 = a.Approval_As;
                                self.header.Sign_Position1 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 2){
                                self.labelAppr2 = a.Approval_As;
                                self.header.Appr_As2 = a.Approval_As;
                                self.header.Sign_Position2 =  a.Sign_Position;
                            }
                        });
                    }

                    this.is_mekanikal =  arrInsepction.filter(a=> a.includes("MEKANIKAL")).length > 0;
                    this.is_electrical = arrInsepction.filter(a=> a.includes("ELECTRICAL")).length > 0;
                    this.is_sipil =  arrInsepction.filter(a=>a.includes("SIPIL")).length > 0;
                })
                .catch(function (error) {
                    self.showError("Error", error);
                });
        },
        saveData() {
            this.$emit('block-ui');
            var self = this;
            var data = new FormData();

            data.append("Id", this.header.Id);
            data.append("Main_Data_Id", this.header.Main_Data_Id);
            if(this.header.Date_Time) data.append("Date_Time1", moment(this.header.Date_Time).format('YYYY/MM/DD').toString());
            data.append("Contractor_Code", this.header.Contractor_Code);
            data.append("Company_Code", this.header.Company_Code);
            data.append("Location_Code", this.header.Location_Code);
            if(this.header.Area_Plant) data.append("Area_Plant", this.header.Area_Plant);
            if(this.header.Scope) data.append("Scope", this.header.Scope);

            if(this.header.No_SPK != null)
                data.append("No_SPK", this.header.No_SPK);
            if(this.header.No_SPO != null)
                data.append("No_SPO", this.header.No_SPO);
            if(this.header.Report_Number !=null)
                data.append("Report_Number", this.header.Report_Number);
            if(this.header.Username_Inspector !=null)
                data.append("Username_Inspector", this.header.Username_Inspector);
            if(this.header.Username_QC_Head !=null)
                data.append("Username_QC_Head", this.header.Username_QC_Head);
            if(this.header.Username_QC !=null)
                data.append("Username_QC", this.header.Username_QC);

            if(this.header.Username_QC_Electrical !=null)
                data.append("Username_QC_Electrical", this.header.Username_QC_Electrical);
            if(this.header.Username_QC_Sipil !=null)
                data.append("Username_QC_Sipil", this.header.Username_QC_Sipil);
            if(this.header.Username_QC_Mekanikal !=null)
                data.append("Username_QC_Mekanikal", this.header.Username_QC_Mekanikal);

            if(this.header.Appr_As1 !=null)
                data.append("Appr_As1", this.header.Appr_As1);
            if(this.header.Appr_As2 !=null)
                data.append("Appr_As2", this.header.Appr_As2);

            if(this.header.Contractor_Title !=null) data.append("Contractor_Title", this.header.Contractor_Title);
            if(this.header.Accept_Repair !=null) data.append("Accept_Repair", this.header.Accept_Repair);
            
            if(this.header.Days == null)
                this.header.Days = 0;   
            
            if(this.header.Days !=null) data.append("Days", this.header.Days);

            if(this.header.Comments !=null) data.append("Comments", this.header.Comments);

            if(this.header.Status != null)
                data.append("Status", this.header.Status);
            
            data.append("mode", this.header.mode);
            
            if(this.header.Reason != null)
                data.append("Reason", this.header.Reason);

            for(var i=0; i< this.header.Participants.length;i++){
                var item = this.header.Participants[i];
                if(item.mode != null)
                    data.append("Participants[" + i + "].mode", item.mode);
                if(item.Doc_QC_Id != null)
                    data.append("Participants[" + i + "].Doc_QC_Id", item.Doc_QC_Id);
                if(item.Id != null)
                    data.append("Participants[" + i + "].Id", item.Id);
                if(item.Name != null)
                    data.append("Participants[" + i + "].Name", item.Name);
                if(item.Position != null)
                    data.append("Participants[" + i + "].Position", item.Position);
                if(item.Company != null)
                    data.append("Participants[" + i + "].Company",  item.Company);
                if(item.Remark != null)
                    data.append("Participants[" + i + "].Remark", item.Remark);
            }
               
            for(var k= 0; k< this.header.Details.length; k++){
                var detail = this.header.Details[k];
                if(detail.Id != null)
                    data.append("Details[" + k + "].Id", detail.Id);
                if(detail.mode != null)
                    data.append("Details[" + k + "].mode", detail.mode);
                if(detail.Doc_QC_Id != null)
                    data.append("Details[" + k + "].Doc_QC_Id", detail.Doc_QC_Id);
                if(detail.Description != null)
                    data.append("Details[" + k + "].Description", detail.Description);


                for(var j=0; j< this.header.Details[k].Inspections.length;j++){
                    var inspections = this.header.Details[k].Inspections[j];
                    if(inspections.mode != null)
                        data.append("Details[" + k + "].Inspections[" + j + "].mode", inspections.mode);
                    if(inspections.Id != null)
                        data.append("Details[" + k + "].Inspections[" + j + "].Id", inspections.Id);
                    if(inspections.Doc_QC_Id != null)
                        data.append("Details[" + k + "].Inspections[" + j + "].Doc_QC_Id", inspections.Doc_QC_Id);
                    if(inspections.Doc_QC_Detail_Id != null)
                        data.append("Details[" + k + "].Inspections[" + j + "].Doc_QC_Detail_Id", inspections.Doc_QC_Detail_Id);
                    if(inspections.Scope != null)
                        data.append("Details[" + k + "].Inspections[" + j + "].Scope", inspections.Scope);
                    if(inspections.Date != null)
                        data.append("Details[" + k + "].Inspections[" + j + "].Date1", moment(inspections.Date).format('YYYY/MM/DD').toString());
                    if(inspections.Log_Date != null)
                        data.append("Details[" + k + "].Inspections[" + j + "].Log_Date1", moment(inspections.Log_Date).format('YYYY/MM/DD').toString());
                    if(inspections.Inspection_Previosly != null)
                        data.append("Details[" + k + "].Inspections[" + j + "].Inspection_Previosly", inspections.Inspection_Previosly);
                    if(inspections.Inspection_Currently != null)
                        data.append("Details[" + k + "].Inspections[" + j + "].Inspection_Currently", inspections.Inspection_Currently);
                    if(inspections.Currently != null)
                        data.append("Details[" + k + "].Inspections[" + j + "].Currently", inspections.Currently);
                    if(inspections.Inspection != null)
                        data.append("Details[" + k + "].Inspections[" + j + "].Inspection", inspections.Inspection);
                    if(inspections.Result != null)
                        data.append("Details[" + k + "].Inspections[" + j + "].Result", inspections.Result);
                    if(inspections.Issue != null)
                        data.append("Details[" + k + "].inspections[" + j + "].Issue", inspections.Issue);
                    if(inspections.Identitas != null)
                        data.append("Details[" + k + "].inspections[" + j + "].Identitas", inspections.Identitas);
                    if(inspections.Rectification != null)
                        data.append("Details[" + k + "].Inspections[" + j + "].Rectification", inspections.Rectification);
                    if(inspections.Is_Disable != null)
                        data.append("Details[" + k + "].Inspections[" + j + "].Is_Disable", inspections.Is_Disable);
                
                    if(inspections.files_data1 != null){
                        for(var z=0; z < inspections.files_data1.length;z++){
                            var file1 = inspections.files_data1[z];
                            data.append("Details[" + k + "].Inspections[" + j + "].attachments1.File", file1, file1.name);
                        } 
                    }

                    if(inspections.files_data != null){
                        for(var x=0; x < inspections.files_data.length;x++){
                            var file = inspections.files_data[x];
                            data.append("Details[" + k + "].Inspections[" + j + "].attachments.File", file, file.name);
                        }
                    }
                }
            }


            this.$axios.post(this.url, data, 
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                .then((response) => {
                    if (response.data.success) {
                        if (this.mode == this.$FORM_MODE_DELETE) {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Deleted', detail: "QC Final has been deleted successfully", life: 3000 } });
                        } else {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "QC Final has been saved successfully", life: 3000 } });
                        }

                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            if(this.$router.options.history.state.back != null)
                this.$router.push({ path: this.$router.options.history.state.back });
            else 
              this.$router.push({ path: "Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            this.submitted2 = true;
            var self = this;
            if(self.mode != this.$FORM_MODE_DELETE){

                //|| (this.header.Accept_Repair == this.$Accept_Repair.REPAIR && !this.header.Days) !this.header.Doc_No || !this.header.Username_Inspector|| || !this.header.Username_QC || !this.header.No_SPK || || !this.header.Accept_Repair || || !this.header.Date_Of_Sign
                if (!this.header.Date_Time || !this.header.Contractor_Code || !this.header.Area_Plant||!this.header.Scope || 
                    (this.header.isSpo &&!this.header.No_SPO) || 
                    !this.header.Contractor_Title || !this.header.Username_Inspector || 
                    !this.header.Comments || (this.labelAppr1 &&!this.header.Username_QC_Head) ||
                    (!this.header.Username_QC_Sipil && this.is_sipil) || (!this.header.Username_QC_Mekanikal && this.is_mekanikal) || (!this.header.Username_QC_Electrical && this.is_electrical)
                    ||(!this.header.Reason && this.header.Status == this.$APPROVAL_STATUS.DONE)) {
                    return;
                }
              
                var Participants = this.header.Participants.filter(a=> a.mode != this.$FORM_MODE_DELETE && a.Name);
                var Details = this.header.Details.filter(a=> a.mode != this.$FORM_MODE_DELETE);
    
                if(Participants.length == 0){
                    self.showError("Error", "Must have one participant")
                    return;
                }
                if(Details.length == 0){
                    self.showError("Error", "Must have one inspection")
                    return;
                }
                var Inspections = this.header.Details[0].Inspections.filter(a=> a.mode != this.$FORM_MODE_DELETE && a.Scope);
                if(Inspections.length == 0){
                    self.showError("Error", "Must have one inspection Photos")
                    return;
                }
    
                let details = this.header.Details.filter(a=> a.mode != this.$FORM_MODE_DELETE);
                let resultNothing = this.header.Details.filter(a=> a.mode != this.$FORM_MODE_DELETE && a.Inspections.filter(b=> b.Result== null).length > 0 );
                let isvalidationDuplicate = false;
                let a=0;
              
                for(let i = 0; i < details.length; i++){
                    a = i+1;
                    var getArrIdentitas = details[i].Inspections.filter(a=> a.mode != this.$FORM_MODE_DELETE).map(x => x.Identitas);
                    if(self.checkIfArrayIsUnique(getArrIdentitas)){
                        self.showError("Error", "Duplicate Id in Inspection #" + a.toString());
                        isvalidationDuplicate = true;
                        break;
                    }
    
                    if(details.length > 50){
                        if(i != 0){
                            var getArrPreviosInspection = details[i - 1].Inspections.filter(a=> a.mode != this.$FORM_MODE_DELETE).map(x => x.Identitas);
                            var getArrInspection = details[i].Inspections.filter(a=> a.mode != this.$FORM_MODE_DELETE).map(x => x.Identitas);
                            let result = getArrInspection.filter(o1 => !getArrPreviosInspection.some(o2 => o1 === o2));
                            if(result.length > 0){
                                self.showError("Error", "Id "+ result.join(",") + " not in Inspection #" + (a - 1).toString());
                                isvalidationDuplicate = true;
                                break;
                            }
    
                            var getArrPreviosInspection1 = details[i - 1].Inspections.filter(a=> a.mode != this.$FORM_MODE_DELETE && a.Result != "REPAIR");
                            var getArrInspection1 = details[i].Inspections.filter(a=> a.mode != this.$FORM_MODE_DELETE);
                            let result1 = getArrInspection1.filter(o1 => getArrPreviosInspection1.some(o2 => o1.Scope === o2.Scope && o1.Identitas === o2.Identitas && o1.Result == o2.Result));
                            if(result1.length > 0){
                                var data = result1[0];
                                self.showError("Error", "Inspection #" + a.toString() + " with scope "+ data.Scope + ", Id " + data.Identitas +", and result " + data.Result + " already exists in Inspection #" + (a - 1).toString());
                                isvalidationDuplicate = true;
                                break;
                            }
    
                            var getArrPreviosInspection2 = details[i - 1].Inspections.filter(a=> a.mode != this.$FORM_MODE_DELETE && a.Result == "ACCEPT");
                            var getArrInspection2 = details[i].Inspections.filter(a=> a.mode != this.$FORM_MODE_DELETE && a.Result == "REPAIR");
                            let result2 = getArrInspection2.filter(o1 => getArrPreviosInspection2.some(o2 => o1.Scope === o2.Scope && o1.Identitas === o2.Identitas));
                            if(result2.length > 0){
                                var data1 = result2[0];
                                self.showError("Error", "Inspection #" + a.toString() + " with scope "+ data1.Scope + ", Id " + data1.Identitas + " already accept in Inspection #" + (a - 1).toString());
                                isvalidationDuplicate = true;
                                break;
                            }
                            
                        }
                      
                    }
                   
                } 
                
                if(isvalidationDuplicate){
                    return;
                }
    
                if(resultNothing.length > 0){
                    self.showError("Error", "Must type result in inspections photos")
                    return;
                }

                
            }

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        confirmDraft(event) {
            this.submitted = true;
            this.submitted2 = false;
            var self = this;
            //|| (this.header.Accept_Repair == this.$Accept_Repair.REPAIR && !this.header.Days)  !this.header.Doc_No || !this.header.Username_Inspector|||| !this.header.Username_QC !this.header.No_SPK || || !this.header.Accept_Repair || !this.header.Date_Of_Sign 
            if (!this.header.Date_Time || !this.header.Contractor_Code || !this.header.Area_Plant||!this.header.Scope || 
                (this.header.isSpo &&!this.header.No_SPO) || 
                !this.header.Contractor_Title || !this.header.Username_Inspector || 
                !this.header.Comments ||
                (!this.header.Username_QC_Sipil && this.is_sipil) || (!this.header.Username_QC_Mekanikal && this.is_mekanikal) || (!this.header.Username_QC_Electrical && this.is_electrical)) {
                return;
            }

            let details = this.header.Details.filter(a=> a.mode != this.$FORM_MODE_DELETE);
            let resultNothing = this.header.Details.filter(a=> a.mode != this.$FORM_MODE_DELETE && a.Inspections.filter(b=> b.Result== null).length > 0 );
            let isvalidationDuplicate = false;
            let a=0;

            for(let i = 0; i < details.length; i++){
                a = i+1;
                var getArrIdentitas = details[i].Inspections.filter(a=> a.mode != this.$FORM_MODE_DELETE).map(x => x.Identitas);
                if(self.checkIfArrayIsUnique(getArrIdentitas)){
                    self.showError("Error", "Duplicate Id in Inspection #" + a.toString());
                    isvalidationDuplicate = true;
                    break;
                }

                if(details.length > 1){
                    if(i != 0){
                        var getArrPreviosInspection = details[i - 1].Inspections.filter(a=> a.mode != this.$FORM_MODE_DELETE).map(x => x.Identitas);
                        var getArrInspection = details[i].Inspections.filter(a=> a.mode != this.$FORM_MODE_DELETE).map(x => x.Identitas);
                        let result = getArrInspection.filter(o1 => !getArrPreviosInspection.some(o2 => o1 === o2));
                        if(result.length > 0){
                            self.showError("Error", "Id "+ result.join(",") + " not in Inspection #" + (a - 1).toString());
                            isvalidationDuplicate = true;
                            break;
                        }

                        var getArrPreviosInspection1 = details[i - 1].Inspections.filter(a=> a.mode != this.$FORM_MODE_DELETE && a.Result != "REPAIR");
                        var getArrInspection1 = details[i].Inspections.filter(a=> a.mode != this.$FORM_MODE_DELETE);
                        let result1 = getArrInspection1.filter(o1 => getArrPreviosInspection1.some(o2 => o1.Scope === o2.Scope && o1.Identitas === o2.Identitas && o1.Result == o2.Result));
                        if(result1.length > 0){
                            var data = result1[0];
                            self.showError("Error", "Inspection #" + a.toString() + " with scope "+ data.Scope + ", Id " + data.Identitas +", and result " + data.Result + " already exists in Inspection #" + (a - 1).toString());
                            isvalidationDuplicate = true;
                            break;
                        }

                        var getArrPreviosInspection2 = details[i - 1].Inspections.filter(a=> a.mode != this.$FORM_MODE_DELETE && a.Result == "ACCEPT");
                        var getArrInspection2 = details[i].Inspections.filter(a=> a.mode != this.$FORM_MODE_DELETE && a.Result == "REPAIR");
                        let result2 = getArrInspection2.filter(o1 => getArrPreviosInspection2.some(o2 => o1.Scope === o2.Scope && o1.Identitas === o2.Identitas));
                        if(result2.length > 0){
                            var data1 = result2[0];
                            self.showError("Error", "Inspection #" + a.toString() + " with scope "+ data1.Scope + ", Id " + data1.Identitas + " already accept in Inspection #" + (a - 1).toString());
                            isvalidationDuplicate = true;
                            break;
                        }
                        
                    }
                  
                }
               
            } 

            if(isvalidationDuplicate){
                return;
            }
            
            if(resultNothing.length > 0){
                self.showError("Error", "Must type result in inspections photos")
                return;
            }

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure save as draft ?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if(this.mode == this.$FORM_MODE_CREATE)
                        this.header.mode = this.$FORM_MODE_DRAFT;
                    else if(this.mode == this.$FORM_MODE_EDIT)
                        this.header.mode = this.$FORM_MODE_DRAFT_EDIT;
                    else
                        this.header.mode = this.mode;
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetailParticipant() {
            var newDetail = this.participant;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.Participants.push(det);
        },
        deleteDetailParticipant(event) {
            if (event) {
                var detail = this.header.Participants[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.Participants.splice(this.header.Participants.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditCompleteParticipant(event) {
            this.editDetailParticipant(event.index);
        },
        editDetailParticipant(index) {
            if (this.header && this.header.Participants) {
                let mode = this.header.Participants[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Participants[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        addDetailInspection(event) {
            var newDetail = this.inspection;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };
            var length = 0
          
            if(event.data.Item_No != null){
               length = event.data.Item_No - 1;
            }else{
                var arrDet = [...this.header.Details];
                var index = arrDet.indexOf(event.data);
                if(index != null){
                    event.data.Item_No = index + 1;
                    length = index;
                }
            }
           
            if(length >= 0){
                det.Inspection_Currently = event.data.Item_No;
                det.Inspection_Previosly = (length == 0) ? null : (length).toString();
            }

            event.data.Inspections.push(det);
        },
        deleteDetailInspection(event,e) {
            if (event) {
                var detail = e.data;
                if (e.data.mode == this.$FORM_MODE_CREATE)
                    event.data.Inspections.splice(this.header.Details[event.index].Inspections.indexOf(detail), 1);
                else e.data.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditCompleteInspection(event,header) {
            this.editDetailInspection(event,header);
        },
        editDetailInspection(index,i) {
            if (this.header.Details && i.data.Inspections) {
                let mode = index.data.mode;
                if (mode == this.$FORM_MODE_UNCHANGED) {
                    i.data.mode = this.$FORM_MODE_EDIT;
                    index.data.mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        addDetail() {
            var newDetail = this.detail;
            newDetail.Inspections = [];
            var index = [...this.header.Details];
            newDetail.mode = this.$FORM_MODE_CREATE;
            newDetail.Description = "Inspection";
            newDetail.Item_No = index.length + 1;
           
            var det = { ...newDetail };

            this.header.Details.push(det);
        },
        deleteDetail(data) {
            if (data) {
                var detail = this.header.Details[data.index];

                if (data.data.mode == this.$FORM_MODE_CREATE) this.header.Details.splice(this.header.Details.indexOf(data.data), 1);
                else data.data.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete(event) {
            this.editDetail(event.index);
        },
        editDetail(index) {
            if (this.header && this.header.Details) {
                let mode = this.header.Details[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Details[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        onFileRemove(files,data) {
                data.files_data = [];
                for(var i = 0; i<files.length;i++){
                    data.files_data.push(event.files[i]);
                }
        },
        onFileRemove1(files,data) {
                data.files_data1 = [];
                for(var i = 0; i<files.length;i++){
                    data.files_data1.push(event.files[i]);
                }
        },
        onFileSelect(event, data) {
            data.files_data = [];
            for(var i = 0; i<event.files.length;i++){
                data.files_data.push(event.files[i]);
            }
        },
        onFileSelect1(event, data) {
            data.files_data1 = [];
            for(var i = 0; i<event.files.length;i++){
                data.files_data1.push(event.files[i]);
            }
        },
        onFileSelectUpload(event) {
            this.detailFiles = event.files;
            this.uploadFile = true;
        },
        onDownloadFile1(file){
            var self = this;
            this.$axios.get(this.url + "download_currently/" + file.id + "/" + file.name, {
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file.name);
                    document.body.appendChild(link);
                    link.click();
                    
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                    //self.showAssignModal = false;
                });
        },
        onDownloadFile2(file){
            var self = this;
            this.$axios.get(this.url + "download_previosly/" + file.id + "/" + file.name, {
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file.name);
                    document.body.appendChild(link);
                    link.click();
                    
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                });
        },
    },
    computed:{},
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;
        this.mainid = this.$route.query.mainid ?? 0;
        if(this.$router.options.history.state.back != null){
            var indexName = this.$router.options.history.state.back.split("/");
            if(indexName[1] == "MainData")
                this.indexName = "MainDataIndex";
        }
        this.getData();
    }
}
</script>
<style>
.p-fileupload .p-fileupload-content {
    padding: 0rem;
}
</style>